import { render } from "./ModalPrintWitness.vue?vue&type=template&id=4d18ed70"
import script from "./ModalPrintWitness.vue?vue&type=script&lang=js"
export * from "./ModalPrintWitness.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__